import * as React from 'preact/compat'
import SVG from '../SVG'
import css from '../../../css/v9/components/video-player.pcss.json'

interface StateTypes {
  message?: {
    icon: string,
    text?: string
  }
}

export default class OSD extends React.Component<{}, StateTypes> {

  state: StateTypes = {
  }

  removeTimeout: number = 0

  componentDidUpdate(_previousProps: Readonly<{}>, previousState: Readonly<StateTypes>) {
    if (this.state.message && this.state.message !== previousState.message) {
      if (this.removeTimeout) {
        clearTimeout(this.removeTimeout)
      }
      // @ts-ignore
      this.removeTimeout = setTimeout(() => {
        this.setState({ message: null })
      }, 300)
    }
  }

  show = (message: {
    icon: string,
    text?: string
  }) => {
    this.setState({ message })
  }

  render() {
    if (!this.state.message) {
      return ''
    }

    return <div className={css['osd']}>
      <div className={css['osd-inner']}>
        <SVG i={this.state.message.icon} />
        {this.state.message.text && <span>{this.state.message.text}</span>}
      </div>
    </div>
  }
}
